import * as React from "react";

import {
	alpha,
	Theme
} from "@mui/material/styles";

import {
	withStyles
} from "@mui/styles";

import { commonErrorParameters } from "./fields";

import { CalendarPickerView } from "@mui/x-date-pickers/internals/models";
import { DateTime } from "luxon";
import { DatePicker } from '@mui/x-date-pickers';
import { Controller } from "react-hook-form";
import {
	ClassNameMap,
	TextField
} from "@mui/material";

interface ZPlayDatePickerState {
	value?: Date
}

interface ZPlayDatePickerProps
{
	name: string,
	label: string,
	value?: Date,
	control: any,
	trigger: any,
	formState: any,
	disabled?: boolean,
	required?: boolean,
	minDate?: DateTime,
	maxDate?: DateTime,
	views?: CalendarPickerView[],
	classes: ClassNameMap<"root">,
	openTo?: CalendarPickerView,
	showTodayButton?: boolean,
	todayText?: React.ReactNode,
	cancelText?: React.ReactNode,
}

const styles = (theme: Theme) => ({
	root: {
		"& .MuiFilledInput-root": {
			overflow: "hidden",
			borderRadius: "0px",
			backgroundColor: "#FFFFFF",
			transition: theme.transitions.create([
				"border-color",
				"background-color",
				"box-shadow",
			]),
			"&:hover": {backgroundColor: "#FFFFFF",},
			"&.Mui-focused": {
				backgroundColor: "#FFFFFF",
				boxShadow: `${alpha("#000000", 0.25)} 0 0 0 2px`,
				borderColor: "#000000",
			}
		}
	}
});

class ZPlayDatePicker extends React.Component<ZPlayDatePickerProps, ZPlayDatePickerState>
{
	static defaultProps = {
		disabled: false,
		required: false,
		showTodayButton: false,
		todayText: "Today",
		cancelText: "Cancel",
		views: undefined,
		openTo: "day"
	};

	componentDidMount() {
		this.setState(() => ({
			value: this.props.value
		}))
	}

	render()
	{
		const {classes} = this.props;

		return (<Controller
			name={this.props.name}
			defaultValue={this.state?.value || this.props.value || ''}
			control={this.props.control}
			render={({field}) => (<DatePicker
				{...field}
				mask="__/__/____"
				inputFormat="dd/MM/yyyy"
				minDate={this.props.minDate}
				maxDate={this.props.maxDate}
				openTo={this.props.openTo}
				showTodayButton={this.props.showTodayButton}
				todayText={this.props.todayText}
				cancelText={this.props.cancelText}
				label={this.props.label}
				disabled={this.props.disabled || this.props.formState.isSubmitting}
				onChange={(value) => {
					field.onChange(value);
					this.setState(() => ({
						value: value
					}))
					this.props.trigger(this.props.name);
				}}
				renderInput={(params) => <TextField
					{...field}
					{...params}
					className={classes.root}
					size="small"
					margin="dense"
					fullWidth
					variant={"filled"}
					required={this.props.required}
					disabled={this.props.disabled || this.props.formState.isSubmitting}
					name={this.props.name}
					value={this.state?.value}
					{...commonErrorParameters(this.props.name, this.props.formState)} />}
			/>)}
		/>);
	}
}

export default withStyles(styles)(ZPlayDatePicker);

